import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_6xe433jf94: FaireCollectionEntity = {
  token: "pbc_6xe433jf94",
  type: "collection",
  name: "Fairytale",
  heroImageUrl:
    "https://cdn.faire.com/fastly/28077f006371c91553b1b633627e4c858bab9c5945e82dcba563cf65127f7df1.jpeg",
  itemCount: 10,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:21.404Z",
    importedBy: "entity-db-import-collections",
  },
};
